import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

const classManage = () =>
  import(
    /* webpackChunkName: "small-class-manage" */ "@/views/teacherSmallClassTime/classManage/index.vue"
  );
const classManageOpen = () =>
  import(
    /* webpackChunkName: "small-class-manage-open" */ "@/views/teacherSmallClassTime/classManage/open.vue"
  );
const classManageClose = () =>
  import(
    /* webpackChunkName: "small-class-manage-close" */ "@/views/teacherSmallClassTime/classManage/close.vue"
  );
//小班课选择请假时段
const classManageLeave = () =>
  import(
    /* webpackChunkName: "small-class-manage-close" */ "@/views/teacherSmallClassTime/classManage/leave.vue"
  );

const fixedTime = () =>
  import(
    /* webpackChunkName: "small-fixed-time" */ "@/views/teacherSmallClassTime/fixedTime/index.vue"
  );
// 小班课请假
const leave = () =>
  import(
    /* webpackChunkName: "small-fixed-time" */ "@/views/teacherSmallClassTime/leave/index.vue"
  );
// 小班课请假详情
const leaveInfo = () =>
  import(
    /* webpackChunkName: "small-fixed-time" */ "@/views/teacherSmallClassTime/leave/info.vue"
  );
// 小班课请假详情页面
const leaveDetails = () =>
  import(
    /* webpackChunkName: "apply-break-rule" */ "@/views/teacherSmallClassTime/leave/details.vue"
  );
// 教管考核时段
const openAssessmentPeriod = () =>
  import(
    /* webpackChunkName: "small-open-assessment-period" */ "@/views/teacherSmallClassTime/openAssessmentPeriod/index.vue"
  );
// 教管考核时段-无权限
const timeManageNoAuthorize = () =>
  import(
    /* webpackChunkName: "small-time-manage-no-authorize" */ "@/views/teacherSmallClassTime/openAssessmentPeriod/noAuthorize.vue"
  );
const teacherUserCenter = () =>
  import(
    /* webpackChunkName: "small-teacher-user-center" */ "@/views/teacherSmallClassTime/userCenter/index.vue"
  );
/**
 * 老固定时段管理(废弃)
 */
const fixedTimeIndex = () =>
  import(
    /* webpackChunkName: "small-fixed-time-index" */ "@/views/teacherSmallClassTime/fixedTime/index.vue"
  );
/**
 * 固定时段管理-公众号&app老师
 */
const fixedTimeManageIndex = () =>
  import(
    /* webpackChunkName: "small-fixed-time-manage-index" */ "@/views/teacherSmallClassTime/fixedTime/manage/index.vue"
  );
// teachingManage
/**
 * 固定时段管理-教管
 */
const fixedTimeTeachingManage = () =>
  import(
    /* webpackChunkName: "small-fixed-time-teaching-manage" */ "@/views/teacherSmallClassTime/fixedTime/manage/teachingManage.vue"
  );
/**
 * 固定时段管理-关闭时段申请
 */
const fixedTimeManageClose = () =>
  import(
    /* webpackChunkName: "small-fixed-time-manage-close" */ "@/views/teacherSmallClassTime/fixedTime/manage/close.vue"
  );
/**
 * 固定时段管理-关闭时段影响学员列表
 */
const effectTimeList = () =>
  import(
    /*webpackChunkName: "fixedTimeClose" */ "@/views/teacherSmallClassTime/fixedTime/manage/effectTimeList.vue"
  );
/**
 * 固定时段管理-时段变更记录列表
 */
const fixedTimeRecordList = () =>
  import(
    /* webpackChunkName: "small-fixed-time-record-list" */ "@/views/teacherSmallClassTime/fixedTime/changeRecord/list.vue"
  );
/**
 * 固定时段管理-时段变更记录详情
 */
const fixedTimeRecordDetail = () =>
  import(
    /* webpackChunkName: "small-fixed-time-record-detail" */ "@/views/teacherSmallClassTime/fixedTime/changeRecord/detail.vue"
  );
// 非正式老师个人中心
const userCenterNotFormal = () =>
  import(
    /* webpackChunkName: "small-user-center-not-formal" */ "@/views/teacherSmallClassTime/userCenter/notFormal.vue"
  );
// 小班课老师离职申请
const teacherDimission = () =>
  import(
    /* webpackChunkName: "public-teacher-teacherDimission-index" */ "@/views/teacherSmallClassTime/teacherDimission/index.vue"
  );
// 小班课老师离职申请须知
const dimissionNotice = () =>
  import(
    /* webpackChunkName: "public-teacher-teacherDimission-dimissionNotice-index" */ "@/views/teacherSmallClassTime/teacherDimission/dimissionNotice/index.vue"
  );
// 小班课离职交接单
const delivery = () =>
  import(
    /* webpackChunkName: "public-teacher-teacherDimission-delivery" */ "@/views/teacherSmallClassTime/teacherDimission/delivery/index.vue"
  );
// 功能未开发完成的页面
const pageNotFinished = () =>
  import(
    /* webpackChunkName: "small-page-not-finished" */ "@/views/teacherSmallClassTime/userCenter/noFinish.vue"
  );

export default {
  path: "/teacherSmallClassTime",
  name: "teacherSmallClassTime",
  component: view,
  children: [
    {
      path: "classManage",
      component: view,
      children: [
        {
          path: "",
          component: classManage
        },
        {
          path: "open",
          component: classManageOpen
        },
        {
          path: "close",
          component: classManageClose
        },
        {
          path: "leave",
          component: classManageLeave
        }
      ]
    },
    {
      path: "fixedTime",
      component: view,
      children: [
        {
          name: "fixedTime3Def",
          path: "",
          redirect: "manage/index",
          component: fixedTimeIndex
        },
        {
          name: "manage3",
          path: "manage",
          component: view,
          redirect: "manage/index",
          children: [
            {
              name: "index3",
              path: "index",
              component: fixedTimeManageIndex
            },
            {
              name: "close3",
              path: "close",
              component: fixedTimeManageClose
            },
            {
              name: "effectTimeList",
              path: "effectTimeList",
              meta: {
                keepAlive: true,
                isBack: false
              },
              component: effectTimeList
            },
            {
              name: "teachingManage",
              path: "teachingManage",
              component: fixedTimeTeachingManage
            }
          ]
        },
        {
          name: "record3",
          path: "record",
          component: view,
          redirect: "record/list",
          children: [
            {
              name: "list5",
              path: "list",
              meta: {
                keepAlive: true,
                isBack: false
              },
              component: fixedTimeRecordList
            },
            {
              name: "detail3",
              path: "detail",
              component: fixedTimeRecordDetail
            }
          ]
        }
      ]
    },
    {
      name: "leave",
      path: "leave",
      component: leave,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      name: "leaveInfo4",
      path: "leaveInfo",
      component: leaveInfo
    },
    {
      name: "leaveDetails2",
      path: "leaveDetails",
      component: leaveDetails
    },
    {
      name: "openAssessmentPeriod3",
      path: "openAssessmentPeriod",
      component: openAssessmentPeriod
    },
    {
      name: "timeManageNoAuthorize3",
      path: "timeManageNoAuthorize",
      component: timeManageNoAuthorize
    },
    {
      name: "userCenter3",
      path: "userCenter",
      component: teacherUserCenter
    },
    {
      name: "userCenterNotFormal3",
      path: "userCenterNotFormal",
      component: userCenterNotFormal
    },
    {
      name: "pageNotFinished3",
      path: "pageNotFinished",
      component: pageNotFinished
    },
    {
      name: "teacherDimission",
      path: "teacherDimission",
      component: teacherDimission
    },
    {
      name: "dimissionNotice2",
      path: "dimissionNotice",
      component: dimissionNotice
    },
    {
      name: "delivery",
      path: "delivery",
      component: delivery
    }
  ]
};
